import { Fun } from 'widgets-for-react'
import { BmiBlockStyle } from '../root/cmsPage/blocks/block/bmiBlock/bmiBlockLayout'
import { CtaBlockStyle } from '../root/cmsPage/blocks/block/ctaBlockLayout'
import { ExpandBlockStyle } from '../root/cmsPage/blocks/block/expandBlock/expandBlockLayout'
import { LinkBlockNestedStyle } from '../root/cmsPage/blocks/block/expandBlock/nestedBlocks/linkBlockNestedLayout'
import { MediaBlockNestedStyle } from '../root/cmsPage/blocks/block/expandBlock/nestedBlocks/mediaBlockNestedLayout'
import { QuoteBlockNestedStyle } from '../root/cmsPage/blocks/block/expandBlock/nestedBlocks/quoteBlockNestedLayout'
import { TextBlockNestedStyle } from '../root/cmsPage/blocks/block/expandBlock/nestedBlocks/textBlockNestedLayout'
import { CookiebarStyle, CookiePlaceholderStyle } from '../root/cookiebar/cookiebarLayout'
import { LinkGridCentraBlockStyle } from '../root/cmsPage/blocks/block/linkGridCentraBlockLayout'
import { LocationExpandBlockStyle } from '../root/cmsPage/blocks/block/locationExpandbleBlok/locationExpandableBlockLayout'
import { NewsTeasersBlockStyle } from '../root/cmsPage/blocks/block/newsTeasersBlock/newsTeasersBlockLayout'
import { PhoneNumbersBlockStyle } from '../root/cmsPage/blocks/block/phoneNumbersBlock/phoneNumbersBlockLayout'
import { RelatedContentBlockStyle } from '../root/cmsPage/blocks/block/relatedContentBlock/relatedContentBlockLayout'
import { SpecialistsBlockStyle } from '../root/cmsPage/blocks/block/specialistsBlock/specialistsBlockLayout'
import { LinkBlockStyle } from '../root/cmsPage/blocks/block/linkBlockLayout'
import { FeaturedContentBlockStyle } from '../root/cmsPage/blocks/block/featuredContentBlockLayout'
import { LinkGridBlockStyle } from '../root/cmsPage/blocks/block/linkGridBlockLayout'
import { LocationBlockStyle } from '../root/cmsPage/blocks/block/locationBlockLayout'
import { MediaBlockStyle } from '../root/cmsPage/blocks/block/mediaBlockLayout'
import { QuoteBlockStyle } from '../root/cmsPage/blocks/block/quoteBlockLayout'
import { TextBlockStyle } from '../root/cmsPage/blocks/block/textBlockLayout'
import { TextImageBlockStyle } from '../root/cmsPage/blocks/block/textImageBlockLayout'
import { CarouselBlockStyle } from '../root/cmsPage/blocks/block/carouselBlockLayout'
import { DossierHighlightBlockStyle } from '../root/cmsPage/blocks/block/dossierHighlightBlock/dossierHighlightBlock.layout'
import { HighlightBlockStyle } from '../root/cmsPage/blocks/block/highlightBlockLayout'

// ----- STANDARD BUILDING BLOCKS -----

export const featuredContentBlockClasses: Fun<'left' | 'right', FeaturedContentBlockStyle> = (imageDirection) => ({
  blockClassName: `block block--featured image--${imageDirection} block--bg block--centra-bg`,
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header',
  introClassName: 'block__intro',
  labelClassName: 'block__label label--m',
  titleClassName: 'block__title title--xl',
  subtitleClassName: 'block__subtitle title--s',
  contentClassName: 'block__content',
  textClassName: 'block__text',
  footerClassName: 'block__footer',
  clickableWrapperClassName: 'block__clickable',
  clickableClassName: 'button--primary',
  clickableLabelClassName: 'button__label',
  clickableIconClassName: 'button__icon',
  // iconId: '#icon--arrow',
  figureClassName: 'block__visual',
  imageClassName: 'block__image',
  pictureClassName: 'block__picture',
})

export const textImageBlockClasses: Fun<'left' | 'right', TextImageBlockStyle> = (imageDirection) => ({
  blockClassName: `block block--text-image image--${imageDirection}`,
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner container--m gutter--m',
  headerClassName: 'block__header',
  contentClassName: 'block__content',
  labelClassName: 'block__label label--m',
  titleClassName: 'block__title title--xl',
  textClassName: 'block__text text--styled',
  introClassName: 'block__intro',
  figureClassName: 'block__visual fit-object',
  imageClassName: 'block__image container',
  footerClassName: 'block__footer block__clickables',
  clickableWrapperClassName: 'block__clickable',
  clickablePrimaryClassName: 'button--primary',
  clickableSecondaryClassName: 'link--arrowed',
  clickableLabelClassName: 'button__label',
  clickableIconClassName: 'button__icon',
  // iconPrimaryId: '#icon--arrow',
  iconSecondaryId: '#icon--arrow',
})

export const carouselBlockClasses: CarouselBlockStyle = {
  blockClassName: 'block block--related block--carousel',
  blockWithHeaderClassName: 'block--has-header',
  blockWithLinkClassName: 'block--has-link',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header container--m gutter--m',
  titleClassName: 'block__title title--xl',
  introClassName: 'block__intro',
  contentClassName: 'block__content',
  listClassName: 'block__list grid',
}

export const textBlockClasses: TextBlockStyle = {
  blockClassName: 'block block--text block--wysiwyg container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  contentClassName: 'block__content',
  textClassName: 'block__text text--styled',
  footerClassName: 'block__footer block__clickables',
  clickableWrapperClassName: 'block__clickable',
  clickablePrimaryClassName: 'button--primary',
  clickableSecondaryClassName: 'link--arrowed',
  clickableLabelClassName: 'button__label',
  clickableIconClassName: 'button__icon',
  // iconPrimaryId: '#icon--arrow',
  iconSecondaryId: '#icon--arrow',
}

export const ctaBlockClasses = (hasImage: boolean): CtaBlockStyle => ({
  blockContentWidthClassName: `block block--cta ${
    hasImage ? 'cta--fw cta--image' : 'cta--cw cta--text block--wysiwyg container--m gutter--m'
  }`,
  blockFullWidthClassName: `block block--cta cta--fw ${
    hasImage ? 'cta--image container--m gutter--m' : 'cta--text block container--m gutter--m'
  }`,
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  contentClassName: 'block__content',
  textClassName: 'block__intro',
  visualClassName: 'block__visual fit-object',
  imageClassName: 'block__image',
  footerClassName: 'block__footer block__clickables',
  clickableWrapperClassName: 'block__clickable',
  clickablePrimaryClassName: 'button--primary',
  clickableSecondaryClassName: 'link--arrowed',
  clickableIconClassName: 'button__icon',
  clickableLabelClassName: 'button__label',
  // iconPrimaryId: '#icon--arrow',
  iconSecondaryId: '#icon--arrow',
})

export const highlightBlockClasses: HighlightBlockStyle = {
  blockClassName: 'block block--highlight container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header',
  labelClassName: 'block__label typo--xs',
  titleClassName: 'block__title title--xl',
  contentClassName: 'block__content',
  textClassName: 'block__intro',
  visualClassName: 'block__visual fit-object',
  imageClassName: 'block__image',
  footerClassName: 'block__footer',
  clickableClassName: 'block__link',
}

export const linkBlockClasses = (isPatientFolders: boolean): LinkBlockStyle => ({
  blockClassName: 'block block--links block--wysiwyg container--m container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  introClassName: 'block__intro',
  contentClassName: 'block__content',
  listClassName: 'block__list list--clickable has-icon',
  itemClassName: 'list__item',
  linkClassName: 'list__link',
  linkLabelClassName: 'list__title',
  linkTextClassName: 'list__subtitle',
  linkIconClassName: 'list__icon',
  iconInternalId: isPatientFolders ? '#icon--SG-folders' : '#icon--arrow',
  iconExternalId: isPatientFolders ? '#icon--SG-folders' : '#icon--external',
})

export const linkListBlockNestedClasses: LinkBlockNestedStyle = {
  blockClassName: 'block--nested block--links block--links-nested container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  contentClassName: 'block__content',
  listClassName: 'block__list list--clickable has-icon',
  itemClassName: 'list__item',
  itemWithLinkClassName: 'list__link',
  itemWithoutLinkClassName: 'list__wrapper',
  linkLabelClassName: 'list__title',
  linkTextClassName: 'list__subtitle',
  linkIconClassName: 'list__icon',
  iconInternalId: '#icon--arrow',
  iconExternalId: '#icon--external',
}

export const linkListBlockNestedGridClasses: LinkBlockNestedStyle = {
  blockClassName: 'block--nested block--links block--links-nested',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  contentClassName: 'block__content',
  listClassName: 'block__list list--clickable grid__list grid',
  itemClassName: 'grid__item',
  itemInnerClassName: 'list__item-grid',
  itemWithLinkClassName: 'list__link list__item',
  itemWithoutLinkClassName: 'list__wrapper',
  linkLabelClassName: 'list__title',
  linkTextClassName: 'list__subtitle',
  readMoreLabelClassName: 'list__readMore',
  linkIconClassName: 'list__icon',
  iconInternalId: '#icon--arrow',
  iconExternalId: '#icon--external',
}

export const linkGridBlockClasses = (withImages: boolean): LinkGridBlockStyle => ({
  blockClassName: withImages
    ? 'block block--linkgrid linkgrid--image block--centra-bg'
    : 'block block--linkgrid linkgrid--plain block--centra-bg',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner container--m gutter--m',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  introClassName: 'block__intro',
  contentClassName: 'block__content',
  listClassName: 'block__list grid',
  gridArticleClassName: 'grid__article',
  gridItemClassName: 'grid__item',
  gridWithLinkClassName: 'grid__inner grid__link',
  gridWithoutLinkClassName: 'grid__inner',
  gridContentClassName: 'grid__content',
  gridHeaderClassName: 'grid__header',
  gridLabelClassName: 'grid__label label--m',
  gridTitleClassName: 'grid__title title--l',
  gridIntroClassName: 'grid__intro',
  gridVisualClassName: 'grid__visual container fit-object',
  gridImageClassName: 'grid__image',
  gridFauxLinkWrapperClassName: 'grid__fauxlink',
  gridFauxLinkClassName: 'button--primary',
  gridFauxLinkLabelClassName: 'button__label',
  gridFauxLinkIconClassName: 'button__icon',
  // iconFauxLinkId: '#icon--arrow',
  footerClassName: 'block__footer',
  clickableWrapperClassName: 'clickable',
  clickableClassName: 'link--arrowed',
  clickableIconClassName: 'link__icon',
  clickableLabelClassName: 'link__label',
  iconId: '#icon--arrow',
})

export const expandBlockClasses = (withImage: boolean = false, asGrid: boolean = false): ExpandBlockStyle => ({
  blockClassName: `block block--expand block--wysiwyg ${asGrid && 'block--expand-grid'} ${withImage || asGrid ? '' : 'container--m gutter--m'}`,
  inviewClassName: 'block--inview',
  innerClassName: `${asGrid ? 'block__inner-grid' : 'block__inner'} ${withImage || asGrid ? 'container--m gutter--m' : ''}`,
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  introClassName: 'block__intro',
  contentClassName: 'block__content',
  listClassName: 'block__list expand',
  expandItemClassName: `${asGrid ? 'expand__item-grid' : 'expand__item'}`,
  expandButtonClassName: `${asGrid ? 'expand__button-grid' : 'expand__button'}`,
  expandTitleClassName: 'expand__title title--m',
  expandSubtitleClassName: 'expand__subtitle',
  expandIconClassName: 'expand__icon',
  expandContentClassName: `${asGrid ? 'expand__content-grid' : 'expand__content'}`,
  expandTextClassName: 'expand__text text--styled',
  footerClassName: 'block__footer',
  clickableWrapperClassName: 'block__clickable',
  clickableClassName: 'button--primary',
  clickableLabelClassName: 'button__label',
  clickableIconClassName: 'button__icon',
  // iconId: '#icon--arrow'
})

export const mediaBlockClasses: MediaBlockStyle = {
  blockClassName: 'block block--media block--wysiwyg container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  introClassName: 'block__intro',
  contentClassName: 'block__content',
  figureContentWidthClassName: 'block__figure figure--cw',
  figureFullWidthClassName: 'block__figure figure--fw',
  figureImageClassName: 'figure--image',
  figureVideoClassName: 'figure--video',
  mediaClassName: 'block__media',
  imageClassName: 'block__image',
  pictureClassName: 'block__picture',
  figCaptionClassName: 'block__figcaption',
  captionClassName: 'block__caption',
  sourceClassName: 'block__source',
  cookiesClassName: 'block__cookies',
  cookiesInnerClassName: 'block__cookies-inner',
  cookiesTextClassName: 'block__cookies-text',
  cookiesClickableClassName: 'block__cookies-action clickable clickable--arrow',
}

export const mediaBlockNestedClasses: MediaBlockNestedStyle = {
  blockClassName: 'block--nested block--media block--media-nested',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  contentClassName: 'block__content',
  mediaClassName: 'block__media',
  figureClassName: 'block__figure figure--cw',
  figureImageClassName: 'figure--image',
  figureVideoClassName: 'figure--video',
  videoClassName: 'block__video',
  imageClassName: 'block__image',
  pictureClassName: 'block__picture',
  figCaptionClassName: 'block__figcaption',
  captionClassName: 'block__caption',
  sourceClassName: 'block__source',
  cookiesClassName: 'cookies',
  cookiesInnerClassName: 'cookies__inner gutter--m',
  cookiesTextClassName: 'cookies__text text--styled',
  cookiesClickableClassName: 'cookies__clickable link',
}

export const textBlockNestedClasses: TextBlockNestedStyle = {
  blockClassName: 'block--nested block--text-nested',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  contentClassName: 'block__content',
  textClassName: 'block__text text--styled',
}

export const quoteBlockClasses: Fun<boolean, QuoteBlockStyle> = (hasImage) => ({
  blockClassName: `block block--quote block--wysiwyg ${hasImage ? 'quote--image' : 'quote--text'} block--centra-bg`,
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner container--m gutter--m',
  contentClassName: 'block__content gutter--m',
  quoteClassName: 'block__quote',
  quoteTextClassName: 'block__text',
  authorClassName: 'block__author block__caption',
  footerClassName: 'block__footer typo--xs',
  clickableWrapperClassName: 'block__clickable',
  clickableClassName: 'block__link link--styled-gray',
  clickableLabelClassName: 'link__label',
  clickableIconClassName: 'link__icon',
  iconId: '#icon--arrow',
  visualClassName: 'block__visual fit-object',
  pictureClassName: 'block__picture',
  imageClassName: 'block__image',
})

export const quoteBlockNestedClasses: QuoteBlockNestedStyle = {
  blockClassName: 'block--nested block--quote-nested block--quote',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  contentClassName: 'block__content gutter--m',
  quoteClassName: 'block__quote',
  quoteTextClassName: 'block__text',
  authorClassName: 'block__author block__caption',
}

export const cookiebarClasses: CookiebarStyle = {
  cookiebarClassName: 'cookiebar',
  cookiebarOuterClassName: 'cookiebar__outer container--m gutter--m',
  cookiebarInnerClassName: 'cookiebar__inner',
  cookiebarTextClassName: 'cookiebar__text',
  cookiebarTitleClassName: 'cookiebar__title title--m',
  cookiebarIntroClassName: 'cookiebar__intro typo--xs text--styled',
  cookiebarFooterClassName: 'cookiebar__footer block__clickables',
  cookiebarClickableWrapperClassName: 'block__clickable',
  cookiebarClickablePrimaryClassName: 'button--primary',
  cookiebarClickableSecondaryClassName: 'button--ghost',
  cookiebarClickableLabelClassName: 'button__label',
  cookiebarClickableIconClassName: 'button__icon',
  cookiebarFormClassName: 'cookiebar__form',
  cookiebarExpandClassName: 'cookiebar__expand link--arrowed',
  cookiebarExpandLabelClassName: 'expand__label link__label',
  cookiebarExpandIconClassName: 'expand__icon button__icon',
  cookiebarFormListClassName: 'cookiebar__list',
  cookiebarFormItemClassName: 'cookiebar__item',
  expandIconId: '#icon--chevron-down',
  iconId: '#icon--arrow',
}

export const cookiePlaceholderClasses: CookiePlaceholderStyle = {
  cookiesClassName: 'cookies bg--secondary',
  cookiesInnerClassName: 'cookies__inner gutter--m',
  cookiesTextClassName: 'cookies__text text--styled',
  cookiesClickableClassName: 'cookies__clickable button--primary',
  cookiesClickableLabelClassName: 'button__label',
  cookiesClickableIconClassName: 'button__icon',
  // iconId: '#icon--arrow',
}

// ----- CUSTOM BUILDING BLOCKS -----

export const relatedContentBlockClasses: RelatedContentBlockStyle = {
  blockClassName: 'block block--related',
  blockWithHeaderClassName: 'block--has-header',
  blockWithLinkClassName: 'block--has-link',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner container--m gutter--m',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--l',
  introClassName: 'block__intro',
  contentClassName: 'block__content',
  listClassName: 'block__list grid',
  gridArticleClassName: 'grid__article',
  gridItemClassName: 'grid__item',
  gridLinkClassName: 'grid__inner grid__link',
  gridContentClassName: 'grid__content',
  gridHeaderClassName: 'grid__header',
  gridLabelClassName: 'grid__label label--m',
  gridTitleClassName: 'grid__title title--m',
  gridIntroClassName: 'grid__intro',
  gridVisualClassName: 'grid__visual container fit-object',
  gridImageClassName: 'grid__image',
  gridDateClassName: 'grid__date typo--xs',
  gridFauxLinkWrapperClassName: 'grid__fauxlink',
  gridFauxLinkClassName: 'fauxlink',
  gridFauxLinkLabelClassName: 'fauxlink__label',
  footerClassName: 'block__footer',
  clickableWrapperClassName: 'clickable m-l-20',
  clickableClassName: 'link--arrowed',
  clickableIconClassName: 'link__icon',
  clickableLabelClassName: 'link__label',
  iconId: '#icon--arrow',
  contentRowClassName: 'block__row',
  dossierClassName: 'dossier__label label--m',
}

export const dossierHighlightBlockClasses: DossierHighlightBlockStyle = {
  blockClassName: 'block block--dossier-highlight',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner container--m gutter--m',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  introClassName: 'block__intro',
  contentClassName: 'block__content grid__item',
  gridListClassName: 'block__list grid__list',
  gridItemClassName: 'grid__list-item',
  gridArticleClassName: 'grid__article',
  gridLinkClassName: 'grid__inner grid__link',
  gridContentClassName: 'grid__content',
  gridHeaderClassName: 'grid__header',
  gridDateClassName: 'grid__date typo--xxs',
  gridTitleClassName: 'grid__title title--m',
  gridFauxLinkWrapperClassName: 'grid__fauxlink',
  gridFauxLinkClassName: 'fauxlink',
  dossierFauxLinkWrapperClassName: 'dossier__footer',
  gridVisualClassName: 'grid__visual container fit-object',
  gridImageClassName: 'grid__image',
  dossierArticleClassName: 'dossier__article grid__item',
  dossierLinkClassName: 'dossier__inner dossier__link',
  dossierContentClassName: 'dossier__content',
  dossierHeaderClassName: 'dossier__header',
  dossierLabelClassName: 'dossier__label label--m',
  dossierTitleClassName: 'dossier__title title--m',
  dossierIntroClassName: 'dossier__intro',
  dossierVisualClassName: 'dossier__visual container fit-object',
  dossierImageClassName: 'dossier__image',
  dossierFauxLinkLabelClassName: 'dossier__fauxlink',
}

export const newsTeasersBlockClasses: NewsTeasersBlockStyle = {
  blockClassName: 'block block--news-teasers block--bg block--centra-bg',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner container--m gutter--m',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  contentClassName: 'block__content',
  listClassName: 'block__list list--clickable',
  itemClassName: 'list__item',
  linkClassName: 'list__link',
  linkLabelClassName: 'list__title title--m',
  linkDateClassName: 'list__date typo--xs',
  linkReadMoreClassName: 'list__readmore typo--xs',
}

export const phoneBlockClasses: PhoneNumbersBlockStyle = {
  blockSmallClassName: 'block block--phone phone--small block--wysiwyg container--m gutter--m',
  blockBigClassName: 'block block--phone phone--big block--wysiwyg container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  listClassName: 'block__list',
  itemClassName: 'block__item',
  linkClassName: 'block__link link--inverted',
}

export const specialistsBlockClasses: SpecialistsBlockStyle = {
  blockClassName: 'block block--specialists block--wysiwyg container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--xl',
  introClassName: 'block__intro',
  contentClassName: 'block__content',
  listClassName: 'block__list grid',
  gridArticleClassName: 'grid__article',
  gridItemClassName: 'grid__item',
  gridWithLinkClassName: 'grid__inner grid__link',
  gridWithoutLinkClassName: 'grid__inner',
  gridContentClassName: 'grid__content',
  gridLabelClassName: 'grid__label label--m',
  gridTitleClassName: 'grid__title title--m',
  gridIntroClassName: 'grid__intro',
  gridVisualClassName: 'grid__visual container fit-object',
  gridImageClassName: 'grid__image',
}

export const locationBlockClasses: LocationBlockStyle = {
  blockClassName: 'block block--location',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner container--m gutter--m',
  headerClassName: 'block__header',
  titleClassName: 'block__title title--l',
  contentClassName: 'block__content',
  listClassName: 'block__list list--clickable',
  itemClassName: 'list__item',
  linkClassName: 'list__link',
  linkLabelClassName: 'list__title title--m',
  linkDateClassName: 'list__date typo--xs',
  linkReadMoreClassName: 'list__readmore typo--xs',
}

export const locationExpandBlockClasses: LocationExpandBlockStyle = {
  locationsWrapperClassName: 'locations',
  locationListClassName: 'locations__list',
  locationItemClassName: 'locations__item',
  locationNameClassName: 'locations__title title--m',
  locationPhoneClassName: 'locations__phone link--inverted',
  locationDescriptionClassName: 'locations__description text--muted',
  locationClickableWrapperClassName: 'locations__clickable',
  locationClickableClassName: 'link--arrowed',
  locationClickableLabelClassName: 'link__label',
  locationClickableIconClassName: 'link__icon',
  locationClickableIconId: '#icon--arrow',
  ...expandBlockClasses(false, false),
}

export const peopleBlockClasses: LocationExpandBlockStyle = {
  ...specialistsBlockClasses,
  blockClassName: 'block block--people block--specialists block--wysiwyg container--m gutter--m',
  footerClassName: 'block__footer',
  clickableWrapperClassName: 'clickable',
  clickableClassName: 'button--primary',
  clickableLabelClassName: 'button__label',
  clickableIconClassName: 'button__icon',
  // iconId: '#icon--arrow',
}
export const bmiBlockClasses: BmiBlockStyle = {
  blockClassName: 'block block--bmi block--wysiwyg container--m gutter--m',
  inviewClassName: 'block--inview',
  innerClassName: 'block__inner',
  headerClassName: 'block__header sr-text',
  contentClassName: 'block__content',
  calculatorClassName: 'block__calculator',
  readOnlyBMIClassName: 'block__bmi title--l text--primary',
  listClassName: 'block__list',
  itemClassName: 'block__item section--bmi',
  resultsClassName: 'block__results text--styled',
}

export const linkGridCentraBlockClasses = (withImages: boolean): LinkGridCentraBlockStyle => ({
  ...linkGridBlockClasses(withImages),
  blockClassName: `block block--linkgrid block--linkgrid-centra ${
    withImages ? 'linkgrid--image' : 'linkgrid--plain'
  } block--centra-bg`,
  gridTitleClassName: 'grid__title title--l',
  gridItem1ClassName: 'grid__item grid__item--1',
  gridItem2ClassName: 'grid__item grid__item--2',
  gridItem3ClassName: 'grid__item grid__item--3',
})
